export default __webpack_public_path__ + "static/media/3-2.f0540186.jpg";